module.exports = __webpack_public_path__ + "img/background064.jpg";